import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from '../../services/payment_type/api_payment_type';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';

export function* fetchListPaymentTypeSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_PAYMENT_TYPE', callListPaymentType, feathersApp);
}

function* callListPaymentType(feathersApp, action) {
  const { filters, silent } = action;  
  yield common.showProgressListTable(silent);
  try {
    const dataParams = { 
      filters, 
      list_type: 'payment_type'
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* deletePaymentTypeFromListSaga(feathersApp) {
  yield takeEvery('DELETE_PAYMENT_TYPE_FROM_LIST', callDeletePaymentTypeFromList, feathersApp);
}

function* callDeletePaymentTypeFromList(feathersApp, action) {
  yield deletePaymentType(feathersApp, action);
  yield delay(2000); 
  yield callListPaymentType(feathersApp, { silent: true });
}

function* deletePaymentType(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deletePaymentType, feathersApp, params);
    }
    yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.PAYMENT_TYPE } });
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}


export function* deletePaymentTypeSaga(feathersApp) {
  yield takeEvery('DELETE_PAYMENT_TYPE', callDeletePaymentType, feathersApp);
}

function* callDeletePaymentType(feathersApp, action) {
  const result = yield deletePaymentType(feathersApp, action);
  yield delay(2000); 
  if (result) {
    browserHistory.push('/admin/payment_type');
  }
}

export function* fetchPaymentTypeForEditSaga(feathersApp) {
  yield takeEvery('FETCH_PAYMENT_TYPE_FOR_EDIT', callFetchPaymentTypeForEdit, feathersApp);
}

function* callFetchPaymentTypeForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchPaymentTypeForEdit, feathersApp, fetchParams);
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}



export function* savePaymentTypeSaga(feathersApp) {
  yield takeEvery("SAVE_PAYMENT_TYPE", callSavePaymentType, feathersApp);
}
function* callSavePaymentType(feathersApp, action) {
  yield common.showProgressSaveRecord();
  const { tenant, user } = yield select();
  try {
    const result = yield call(api.savePaymentType, feathersApp, {
      tenant,
      user,
      data: action.data
    });
    const id = result && result.id;
    yield callFetchPaymentTypeForEdit(feathersApp, { id, silent: true });
    browserHistory.push(`/admin/payment_type/edit/${id}`);
    yield common.doneSaveRecord(result, 'Payment type was saved');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
